export default __webpack_public_path__ + "static/media/M_wdt_c_cap_5.10e5fedc.mp3";